// extracted by mini-css-extract-plugin
module.exports = {"fallback-image-wrapper":"map_fallback-image-wrapper__UfVCa","map-marker-markdown":"map_map-marker-markdown__YF1DB"};